import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class LoginService {
  constructor(private http: HttpClient) {}

  updateFirstLoginPassword = (credentials: {
    username: string;
    password: string;
    token?: string;
  }) => {
    return this.http
      .post(
        `${environment.api.baseUrl}/${environment.api.endpoints.user.userList}/${environment.api.endpoints.user.updateFirstLoginPassword}`,
        credentials
      )
      .toPromise();
  };


  resetPasswordByEmail = (email: string) => {
    return this.http.get(`${environment.api.baseUrl}/${environment.api.endpoints.user.resetPasswordByEmail}?email=${email}`).toPromise()
  }
}
